import React from "react";

const Footer = () => {
	return (
		<>
			<div className="footer__footer">
				<h6 className="text-center py-2 my-0">Copyright &copy; Rajan Gautam</h6>
			</div>
		</>
	);
};

export default Footer;
